// @flow
import initialState from "./initialState";
import * as ActionTypes from "../actions/actionTypes";

export default function (
    state: object = initialState.checkoutSale,
  action: any
) {
  switch (action.type) {
      case ActionTypes.BUILD_CHECKOUT_SALE + ActionTypes.FULFILLED:
          return {
            ...action.payload.data.sale,
            validationResult: action.payload.data.validationResult
          }
      case ActionTypes.STORE_LOCAL_SALE:
          return action.payload;
      case ActionTypes.CLEAR_LOCAL_SALE: //+ ActionTypes.FULFILLED: NO NEED FOR fulfilled as this is not ajax request
          return initialState.checkoutSale;
    default:
      return state;
  }
}
